import { CaseTypeEnum } from '@app/types/create-case';

export const CASE_TYPE_LABEL_KEY: Record<CaseTypeEnum, string> = {
  [CaseTypeEnum.general]: 'createCaseModalTitleGeneral',
  [CaseTypeEnum.claim]: 'createCaseModalTitleClaim',
  [CaseTypeEnum.policy]: 'createCaseModalTitlePolicy',
  [CaseTypeEnum.service]: 'createCaseModalTitleService',
};

/** Full case-type names used in the single-case-type create modal ("Create Service Case", "Service Case Details"). */
export const CASE_TYPE_NAME_KEY: Record<CaseTypeEnum, string> = {
  [CaseTypeEnum.general]: 'caseTypeNameGeneral',
  [CaseTypeEnum.claim]: 'caseTypeNameClaim',
  [CaseTypeEnum.policy]: 'caseTypeNamePolicy',
  [CaseTypeEnum.service]: 'caseTypeNameService',
};

export const CASE_TYPE_ROUTE_SEGMENT: Record<CaseTypeEnum, string> = {
  [CaseTypeEnum.general]: 'general',
  [CaseTypeEnum.claim]: 'claim',
  [CaseTypeEnum.policy]: 'policy',
  [CaseTypeEnum.service]: 'service',
};

/** Must match ORDERED_CASE_TYPES in server/constants/caseTypes.js, not SYSTEM_CASE_TYPES. */
export const ORDERED_CASE_TYPES: CaseTypeEnum[] = [
  CaseTypeEnum.claim,
  CaseTypeEnum.policy,
  CaseTypeEnum.general,
  CaseTypeEnum.service,
];

/** Must match DEFAULT_ALLOWED_CASE_TYPES in server/constants/caseTypes.js. */
export const DEFAULT_ALLOWED_CASE_TYPES: CaseTypeEnum[] = [
  CaseTypeEnum.claim,
  CaseTypeEnum.policy,
  CaseTypeEnum.general,
];

/** Separate from CASE_TYPE_LABEL_KEY, which renders `general` as "Case" for the create-case modal. */
export const ALLOWED_CASE_TYPE_LABEL_KEY: Record<CaseTypeEnum, string> = {
  [CaseTypeEnum.claim]: 'users.assignAllowedCaseTypes.labels.claim',
  [CaseTypeEnum.policy]: 'users.assignAllowedCaseTypes.labels.policy',
  [CaseTypeEnum.general]: 'users.assignAllowedCaseTypes.labels.general',
  [CaseTypeEnum.service]: 'users.assignAllowedCaseTypes.labels.service',
};

export const CASE_TYPE_PLURAL_LABEL_KEY: Record<CaseTypeEnum, string> = {
  [CaseTypeEnum.claim]: 'caseTypePlural.claim',
  [CaseTypeEnum.policy]: 'caseTypePlural.policy',
  [CaseTypeEnum.general]: 'caseTypePlural.general',
  [CaseTypeEnum.service]: 'caseTypePlural.service',
};
